import styled from 'styled-components';

import LoginBg from 'assets/login-bg.jpg';

import { Headline } from 'components/Headline';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: column;

  width: 100%;
  height: 100vh;
  min-height: 80rem;

  background-image: url(${LoginBg});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
`;

const Footer = styled.div`
  margin-top: 2rem;

  text-align: center;
`;

const Title = styled(Headline)`
  margin-top: 6.6rem;
  margin-bottom: 4rem;

  justify-self: flex-start;
`;

const Wrapper = styled.div``;

export { Container, Footer, Title, Wrapper };
